import {
  UPDATE_FK_RATING_REQUEST,
  updateFkRatingSuccess,
  updateFkRatingFailure,
}                               from 'Redux/Action';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { message }              from 'antd';

export function updateFkRatingEpic(action$, store$, { ResultRepository }) {
  return action$.pipe(ofType(UPDATE_FK_RATING_REQUEST), mergeMap(action => from(ResultRepository.updateFkRating(action.payload.resultIds, {
    ratingCode: action.payload.ratingCode
  }))
    .pipe(mergeMap(({ results }) => {
      message.success('Die Bewertung wurden erfolgreich aktualisiert');
      return from([
        updateFkRatingSuccess(results),
      ]);
    }), catchError(error => {
      return from([
        updateFkRatingFailure(error),
      ]);
    }))),);
}
